export const QUOTE_ITEM_ID_PARAM = 'quote_item';
